import { Save } from "lucide-react";
import { ADMIN } from "@/constants/testIds";

const labels = {
        anthropic: "Anthropic",
        openai: "OpenAI",
        gemini: "Google Gemini",
        opencode: "OpenCode Go",
        infinitum: "Infinitum",
};

const PROVIDER_ORDER = ["infinitum", "anthropic", "openai", "gemini", "opencode"];

export const LLMSelector = ({
        value,
        onChange,
        model,
        onModelChange,
        providers = [],
        onSave,
        saving = false,
        compact = false,
        showModel = true,
}) => (
        <div className={`flex flex-col gap-3 ${compact ? "md:flex-row md:items-center" : ""}`}>
                <div
                        data-testid={ADMIN.providerSelect}
                        className="inline-flex flex-wrap gap-1 self-start rounded-lg border border-[var(--line)] bg-[var(--paper-2)] p-1"
                >
                        {PROVIDER_ORDER.map((key) => {
                                const active = value === key;
                                const status = providers.find((item) => item.provider === key);
                                return (
                                        <button
                                                type="button"
                                                key={key}
                                                data-testid={`provider-${key}`}
                                                onClick={() => onChange(key)}
                                                title={status?.configured ? "Chave configurada" : "Chave em falta no .env"}
                                                className={`overline rounded-md px-3 py-2 transition-colors ${
                                                        active
                                                                ? "bg-[var(--paper)] text-[var(--controversy)] shadow-sm"
                                                                : "bg-transparent text-[var(--ink-soft)] hover:text-[var(--ink)]"
                                                }`}
                                        >
                                                {labels[key]}
                                                <span className={status?.configured ? "text-[var(--truth)]" : "text-[var(--deception)]"}>
                                                        {status?.configured ? " · pronto" : " · sem key"}
                                                </span>
                                        </button>
                                );
                        })}
                </div>
                {showModel && (
                        <input
                                value={model}
                                onChange={(event) => onModelChange(event.target.value)}
                                placeholder="Modelo, ex.: claude-sonnet-4-5-20250929"
                                aria-label="Modelo de IA"
                                className="min-w-0 flex-1 border bg-transparent px-3 py-2 font-mono text-sm"
                                style={{ borderColor: "var(--line-strong)" }}
                        />
                )}
                {onSave && (
                        <button
                                type="button"
                                onClick={onSave}
                                disabled={saving || !model.trim()}
                                className="adm-btn adm-btn-outline"
                        >
                                <Save size={13} strokeWidth={1.5} />
                                {saving ? "A guardar..." : "Guardar IA"}
                        </button>
                )}
        </div>
);

export default LLMSelector;
